import type { ComponentConfigV2, ComponentTypeV2 } from '@/types/configurationV2'

/**
 * 신규 config-v2 컴포넌트 생성(순수). firstAttemptOnly 는 기본 false = 비파괴.
 * id 는 호출부에서 생성(uuid 등)해 주입한다(순수성 유지·테스트 용이).
 */
export function buildComponent(
  type: ComponentTypeV2,
  sortOrder: number,
  id: string,
  options: ComponentConfigV2['options'],
): ComponentConfigV2 {
  return {
    id,
    type,
    enabled: true,
    sortOrder,
    firstAttemptOnly: false,
    options,
  }
}

/** firstAttemptOnly 토글(불변 — 새 객체 반환). */
export function setFirstAttemptOnly(
  component: ComponentConfigV2,
  value: boolean,
): ComponentConfigV2 {
  return { ...component, firstAttemptOnly: value }
}
